import { ProductAnalytics } from '../service/analytics';

// CompositeProductAnalytics fans captureEvent / captureLog calls out to every
// registered implementation. Each leg is isolated: if FullStory is blocked by
// a customer firewall and throws, or the OTLP exporter fails to enqueue, the
// other legs still deliver. We swallow errors rather than surfacing them to
// call sites — telemetry failures must never break product code.
export class CompositeProductAnalytics implements ProductAnalytics {
  constructor(private readonly delegates: readonly ProductAnalytics[]) {}

  captureEvent(name: string, properties: Record<string, unknown>): void {
    for (const delegate of this.delegates) {
      try {
        delegate.captureEvent(name, properties);
      } catch (err) {
        logDelegateError_(delegate, 'captureEvent', err);
      }
    }
  }

  captureLog(msg: string, level?: string): void {
    for (const delegate of this.delegates) {
      try {
        delegate.captureLog(msg, level);
      } catch (err) {
        logDelegateError_(delegate, 'captureLog', err);
      }
    }
  }
}

// logDelegateError_ warns once per (delegate class, method) so a delegate bug
// surfaces in devtools without spamming. Telemetry stays non-fatal either way.
const loggedDelegateErrors_ = new Set<string>();
function logDelegateError_(
  delegate: ProductAnalytics,
  method: string,
  err: unknown
) {
  const key = `${delegate.constructor.name}.${method}`;
  if (loggedDelegateErrors_.has(key)) {
    return;
  }
  loggedDelegateErrors_.add(key);
  console.warn(`[analytics] ${key} threw; further errors suppressed`, err);
}
